import { render, staticRenderFns } from "./DashboardEstudiantesActivos.vue?vue&type=template&id=755f1c7a&"
import script from "./DashboardEstudiantesActivos.vue?vue&type=script&lang=js&"
export * from "./DashboardEstudiantesActivos.vue?vue&type=script&lang=js&"
import style0 from "./DashboardEstudiantesActivos.vue?vue&type=style&index=0&id=755f1c7a&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports